import React from 'react';
import { Card, Form, Input, DatePicker, TimePicker, Button } from 'antd';
import moment from 'moment';

const FORMATDATE = 'YYYY-MM-DD';
const FORMATIME = 'HH:mm:ss';

interface Props {
  formValues: any;
  updateField: (field: string, value: any) => void;
  handleSubmit: (e?: any) => void;
  activeCampaignResponse?: any;
}

export const ActiveCampaignCalculator: React.FC<Props> = ({ formValues, updateField, handleSubmit, activeCampaignResponse }) => {
  return (
    <Card title="WhatsApp Throughput Calculator">
      <Form>
        <Form.Item label="Volume of Messages">
          <Input
            type="number"
            value={formValues.volumeMessages}
            onChange={e => updateField('volumeMessages', Number((e.target as HTMLInputElement).value))}
          />
        </Form.Item>

        <Form.Item label="Start Date">
          <DatePicker
            format={FORMATDATE}
            value={formValues.startDate}
            onChange={date => updateField('startDate', date)}
          />
        </Form.Item>

        <Form.Item label="Start Time">
          <TimePicker
            format={FORMATIME}
            value={formValues.startTime}
            onChange={time => updateField('startTime', time)}
          />
        </Form.Item>

        <Form.Item label="End Date">
          <DatePicker
            format={FORMATDATE}
            value={formValues.endDate}
            onChange={date => updateField('endDate', date)}
          />
        </Form.Item>

        <Form.Item label="End Time">
          <TimePicker
            format={FORMATIME}
            value={formValues.endTime}
            onChange={time => updateField('endTime', time)}
          />
        </Form.Item>

        <Button type="primary" onClick={handleSubmit}>
          Calculate
        </Button>
      </Form>

      {activeCampaignResponse && (
        <Card title="Calculation Results" className="mt4">
          <p>
            <strong>Is it possible to send it on time? </strong>
            {activeCampaignResponse.CanSendAllMessagesInTime ? 'Yes' : 'No'}
          </p>
          <p>
            <strong>Total Batches: </strong>
            {activeCampaignResponse.TotalBatches}
          </p>
          <p>
            <strong>Batches Size: </strong>
            {activeCampaignResponse.BatchesSize}
          </p>
          <p>
            <strong>Total Time: </strong>
            {activeCampaignResponse.TotalTime}
          </p>
        </Card>
      )}
    </Card>
  );
};

export default ActiveCampaignCalculator;
